<template>
  <div>
    <a-card title="月度指标配置" style="width:60%;margin: 0 auto;">
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
        <a-form-item label="月度总进水量(m³)">
          <a-input
            v-decorator="['totalMonthlyInflow', { rules: [{ required: true, message: '请输入月度总进水量数值!',pattern:'^[0-9]*$' }] }]"
          />
        </a-form-item>
        <a-form-item label="月度总耗水量(m³)">
          <a-input
            v-decorator="['totalMonthlyWaterConsumption', { rules: [{ required: true, message: '请输入月度总耗水量数值!',pattern:'^[0-9]*$' }] }]"
          />
        </a-form-item>
        <a-form-item label="月度总出水量(m³)">
          <a-input
            v-decorator="['totalMonthlyWaterOutput', { rules: [{ required: true, message: '请输入月度总出水量数值!',pattern:'^[0-9]*$' }] }]"
          />
        </a-form-item>
        <a-form-item label="月度总耗电量(m³)">
          <a-input
            v-decorator="['totalMonthlyElectricityConsumption', { rules: [{ required: true, message: '请输入月度总耗电量数值!',pattern:'^[0-9]*$' }] }]"
          />
        </a-form-item>
        <a-form-item label="启用 / 不启用">
          <a-switch v-decorator="['status', { valuePropName: 'checked' }]" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" html-type="submit">
            配置
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isupdate: false,
      currentId:'',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    };
  },
  created(){
    this.getconfig();
  },
  methods:{
    getconfig(){
      let url = "/pipe-network/total_monthly_targeteds/page";
      this.$http.get(url)
      .then(({data}) => {
        if(parseInt(data.total) > 0){
          this.form.setFieldsValue({
            totalMonthlyInflow: data.list[0].totalMonthlyInflow,
            totalMonthlyWaterConsumption: data.list[0].totalMonthlyWaterConsumption,
            totalMonthlyElectricityConsumption: data.list[0].totalMonthlyElectricityConsumption,
            totalMonthlyWaterOutput: data.list[0].totalMonthlyWaterOutput,
            status:data.list[0].status == 1 ? true : false
          });
          this.currentId = data.list[0].id;
          this.isupdate = true;
        }else{
          this.isupdate = false;
        }
      })
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          switch(values.status){
            case true:
            values.status = 1;
            break;
            case false:
            values.status = 0;
            break;
            default:
            values.status = values.status;
            break;
          }
          let url = "/pipe-network/total_monthly_targeteds";
          let method;
          let data;
          if(this.isupdate == false){
            method = 'post';
            data = values;
          }else{
            method = "put";
            data = {
              id:this.currentId,
              totalMonthlyInflow: values.totalMonthlyInflow,
              totalMonthlyWaterConsumption: values.totalMonthlyWaterConsumption,
              totalMonthlyElectricityConsumption: values.totalMonthlyElectricityConsumption,
              totalMonthlyWaterOutput: values.totalMonthlyWaterOutput,
              status:values.status
              };
          }
          this.$http({
            url: url,
            data:data,
            method: method
          })
          .then((data) => {
            if(data.code == 0){
              this.$message.success(data.message);
              this.getconfig();
            }else{
              this.$message.success(data.message);
            }
          })
        }
      });
    },
  }
}
</script>

<style scoped>

</style>